import { reportActionConstants } from 'home/Reports/actions/reports.constants';
import _ from 'lodash';

// The "Name" column is backed by the `filename` field but renders a localized,
// date-derived title (see ReportsItem.getReportName), so sorting it by
// `filename` would order the rows by a value the user cannot see. Sort by the
// field the title is actually derived from instead. The sorter keeps its
// original name so the asc/desc indicator stays on the Name column.
const SORT_FIELD_BY_COLUMN = {
  filename: 'created_at',
};

const initialState = {
  items: {
    hasMore: false,
    object: [],
    loading: false,
  },
  reportsSorterState: {
    sorter: {
      order: 'desc',
      name: 'updated_at'
    }
  },
};

export const reportsListReducer = (state = initialState, action) => {
  switch (action.type) {
    case reportActionConstants.UPDATE_REPORTS_LIST: {
      action.items.sort((a, b) => (b.created_at.localeCompare(a.created_at)));
      return {
        ...state,
        items: {
          ...state.items,
          object: [
            ...action.items
          ],
        }
      };
    }
    case reportActionConstants.SET_REPORTS_SORTER: {
      const nextState = _.cloneDeep(state);
      const sortField = SORT_FIELD_BY_COLUMN[action.sorterState.name] || action.sorterState.name;
      nextState.items.object.sort((a, b) => (action.sorterState.order === 'asc' ? a[sortField].localeCompare(b[sortField]) : b[sortField].localeCompare(a[sortField])));
      nextState.reportsSorterState.sorter = action.sorterState;
      return {
        ...nextState,
      };
    }
    default:
      return state;
  }
};
